import { environment } from '@/environment';
import { Invoice } from '@/models/invoice';
import { InvoiceDTO } from '@/models/invoice-dto';
import { InvoiceListItem } from '@/models/invoice-list-item';
import { ListParams } from '@/models/list-params';
import { PaginatedList } from '@/models/paginated-list';
import { Product } from '@/models/product';
import axios, { AxiosError } from 'axios';
import store from '../store';

export default {
  url: `${environment.api}/orgs`,
  headers: {
    Authorization: '',
  },

  getOne(orgName: string): Promise<OrgData> {
    orgName = orgName.toLowerCase();

    return axios.get<OrgData>(`${this.url}/${orgName}`).then(res => res.data);
  },

  getInvoices(
    orgName: string,
    queryParams: ListParams
  ): Promise<PaginatedList> {
    this.headers.Authorization = store.getters['auth/getAuthorization'];

    return axios
      .get<InvoiceDTO[]>(`${this.url}/${orgName}/invoices`, {
        params: queryParams,
        headers: this.headers,
      })
      .then(res => {
        const totalItems = parseInt(res.headers['x-total-count']);

        const invoicesDataList: InvoiceListItem[] = res.data.map(invoice => {
          const item: InvoiceListItem = {
            vendor: invoice.vendor.name,
            invoiceNumber: invoice.invoiceNumber,
            date: invoice.date,
            shipTo: invoice.shipTo.name,
            reference: invoice.reference,
            total: invoice.total,
          };
          return item;
        });

        return new PaginatedList(invoicesDataList, totalItems);
      })
      .catch(() => {
        return Promise.reject({
          message: 'Unauthorized: access token is missing or invalid.',
        });
      });
  },

  getInvoice(orgName: string, invoiceId: number): Promise<Invoice> {
    this.headers.Authorization = store.getters['auth/getAuthorization'];

    return axios
      .get<Invoice>(`${this.url}/${orgName}/invoices/${invoiceId}`, {
        headers: this.headers,
      })
      .then(res => res.data)
      .catch((error: AxiosError) => {
        if (error.message.includes('401')) {
          return Promise.reject({
            message: 'Unauthorized: access token is missing or invalid.',
          });
        }

        return Promise.reject({
          message: 'An invoice with the given ID was not found.',
        });
      });
  },

  getProducts(
    orgName: string,
    queryParams: ListParams
  ): Promise<PaginatedList> {
    this.headers.Authorization = store.getters['auth/getAuthorization'];

    return axios
      .get<Product[]>(`${this.url}/${orgName}/products`, {
        params: queryParams,
        headers: this.headers,
      })
      .then(res => {
        const totalItems = parseInt(res.headers['x-total-count']);
        return new PaginatedList(res.data, totalItems);
      })
      .catch(() => {
        return Promise.reject({
          message: 'Unauthorized: access token is missing or invalid.',
        });
      });
  },
};

export type OrgData = {
  name: string;
  logoUrl: string;
  shortName: string;
};
